import { useEffect } from 'react';

import { useIsMobileApp } from 'hooks/useIsMobileApp';

const useHideAndroidNavigationBar = () => {
  const { postMessage, isAndroidApp } = useIsMobileApp();
  useEffect(() => {
    if (!isAndroidApp) {
      return () => {};
    }
    postMessage('toggleNavigationBar', {
      isVisible: false,
    });
    return () => {
      postMessage('toggleNavigationBar', {
        isVisible: true,
      });
    };
  }, [postMessage, isAndroidApp]);
};

// this component should be used very sparingly, as
// it's only meant to be rendered once in the react component tree at a time
export const USE_VERY_SPARINGLY_HideAndroidNavigationBar = () => {
  useHideAndroidNavigationBar();
  return null;
};
